module.exports = __webpack_public_path__ + "img/3.783c2efd.svg";